module.exports = __webpack_public_path__ + "img/右对齐3.8c4e3d1f.svg";